import React from 'react'
import { ReactComponent } from './info-icon.svg'
import { MergeReactElementProps } from '../types'

interface InfoIconProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', InfoIconProps>

export const InfoIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#9a9a9a' } = props
    return <ReactComponent fill={color} ref={ref} {...props} />
  }
)
